import { inject, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ALLOWED_PARAMS } from '@core/constants/allowed-params';
import { ISimple } from '@noda-lib/utils/interfaces';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'filterParams',
  standalone: true,
})
export class FilterParamsPipe implements PipeTransform {
  private route: ActivatedRoute = inject(ActivatedRoute);
  private allowedParamsSet: Set<string> = new Set(ALLOWED_PARAMS);

  transform(additionalParams?: ISimple<string>): Observable<ISimple<string>> {
    return this.route.queryParams.pipe(
      map((params: Params) => {
        const filteredParams: ISimple<string> = this.filterAllowedParams(params);

        return { ...filteredParams, ...additionalParams };
      }),
    );
  }

  private filterAllowedParams(params: ISimple<string>): ISimple<string> {
    const filtered: ISimple<string> = {};

    for (const [key, value] of Object.entries(params)) {
      if (this.allowedParamsSet.has(key)) {
        filtered[key] = value;
      }
    }

    return filtered;
  }
}
